<template>
  <section class="area-erro">
    <div class="fundo">
      <img src="@/assets/imgs/pattern_header.png" alt />
    </div>
    <div class="e404">
      <img src="@/assets/imgs/404.png" alt />
    </div>
    <h2>Página não encontrada</h2>
    <button @click="handleRedirect">VOLTAR</button>
  </section>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    handleRedirect() {
      this.$router.push(this.$store.state.route.from.fullPath);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.area-erro {
  width: 100vw;
  height: 100vh;

  & .fundo {
    user-select: none;
    height: calc(((100vw + 100vh) / 10) + 150px);
    min-height: 40vh;
    width: 100%;

    & img {
      width: 100%;
      height: inherit;
      min-height: inherit;
      object-fit: cover;
    }
  }

  & .e404 {
    user-select: none;
    margin-top: calc(((-100vw - 100vh) / 20) - 40px);

    & img {
      display: block;
      width: calc(((100vw + 100vh) / 5) + 100px);
      margin: 0 auto;
    }
  }

  & h2 {
    font-family: 'VivoType';
    color: $cor_cinza_dark;
    font-size: calc(((100vw + 100vh) / 100) + 14px);
    text-align: center;
    position: absolute;
    top: calc(55% + 35px);
    left: 50%;
    transform: translate(-50%, -50%);
  }

  & button {
    user-select: none;
    display: block;
    margin: 0 auto;
    background: $cor_roxo;
    outline: none;
    font-family: 'VivoType';
    font-weight: bold;
    font-size: calc(((100vw + 100vh) / 200) + 8px);
    letter-spacing: 0.05em;
    border-radius: 5px;
    border: 0px;
    color: white;
    padding: calc(0.5% + 15px) calc(6% + 50px);
    position: absolute;
    bottom: calc(15% - 20px);
    left: 50%;
    transform: translate(-50%, 0);

    &:hover {
      box-shadow: 0px 10px 40px rgba($cor_roxo, 0.4);
    }
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
}

@media all and (min-width: 679px) and (max-width: 1000px) {
}
</style>
